
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'

import CustomTagMixin from '@/@next/mixins/CustomTag'
import { PointsOfInterestService } from '@/@next/services'
import CPoiMiniCard from '@/components/cards/poi-mini-card'
import { CLazyLoadingImage } from '@/components/images'
import { CLoader } from '@/components/loader'
import { CImage } from '@/@next/components/image'

const config = {
  name: 'c-content-poi',
  components: {
    ...CPoiMiniCard,
    CLazyLoadingImage,
    CLoader,
    CImage
  }
}

@Component(config)
export default class Poi extends Mixins(CustomTagMixin, PointsOfInterestService) {
  @Prop({ type: Object, required: true }) content!: any
  @Prop({ type: Object, required: false }) options!: any
  pointOfInterest: any = null

  @Watch('content')
  updateContent () {
    if (this.content && this.content.data.pointOfInterest) {
      this.pointOfInterest = this.content.data.pointOfInterest
    }
  }

  get imageUrl () {
    if (!this.pointOfInterest) return null
    return this.pointOfInterest.image.file.url
  }

  get image () {
    return this.pointOfInterest?.image || null
  }

  get title () {
    if (!this.pointOfInterest) return null
    return this.pointOfInterest.i18n.title.value
  }

  mounted () {
    this.updateContent()
  }

  get summary () {
    const summary = this.options?.summary
    if (!summary) return this.$t('global.forFurther')
    const { isEnabled, text } = this.options?.summary
    if (!isEnabled) return null
    if (!text) return this.$t('global.forFurther')
    const translation = text.find((el: any) => el.language === this.$i18n.locale)
      || text.find((el: any) => el.language === 'fr')
    if (!translation) return this.$t('global.forFurther')
    return translation.value.text
  }

}
